export default class OptionExcavator {
    constructor() {
    }
    getHtml = function(){
        return `
<div class="excavator a">
    <div class="t_p_box">
        <h2 class="title1">기종선택</h2>
    </div>
    <div class="flex">
        <div class="left flex_column main-button-area">
            <div class="item flex" data-index="1" data-range="1~2">초미니</div>
            <div class="item flex" data-index="2" data-range="3~6">미니</div>
            <div class="item flex" data-index="3" data-range="7~8" data-func="toggle">소형</div>
            <div class="item flex" data-index="4" data-range="9~12" data-func="toggle">중대형</div>
            <div class="item flex" data-index="5" data-range="13~15">대형</div>
        </div>
        <div class="right flex_column sub-button-area">
            <div class="flex" data-index="1">
                <div class="item flex_column" data-index="1" data-code="510" data-example="1">008<span class="fz_10 c_a1">(공공팔)</span></div>
                <div class="item flex_column" data-index="2" data-code="512" data-example="1">010<span class="fz_10 c_a1">(공일공)</span></div>
                <div class="item flex op0"></div>
                <div class="item flex op0"></div>
                <div class="item flex op0"></div>
            </div>
            <div class="flex" data-index="2">
                <div class="item flex_column" data-index="3" data-code="520" data-example="1">017<span class="fz_10 c_a1">(공일칠)</span></div>
                <div class="item flex_column" data-index="4" data-code="522" data-example="1">020<span class="fz_10 c_a1">(공이공)</span></div>
                <div class="item flex_column" data-index="5" data-code="524" data-example="1">030<span class="fz_10 c_a1">(공삼공)</span></div>
                <div class="item flex_column" data-index="6" data-code="526" data-example="1">035<span class="fz_10 c_a1">(공삼오)</span></div>
                <div class="item flex op0"></div>
            </div>
            <div class="flex" data-index="3">
                <div class="item flex_column" data-index="7" data-code="540" data-example="1">02Lc<span class="fz_10 c_a1">(공투)</span></div>
                <div class="item flex_column" data-index="8" data-code="530" data-example="1">03w<span class="fz_10 c_a1">(공삼)</span></div>
                <div class="item flex op0"></div>
                <div class="item flex op0"></div>
                <div class="item flex op0"></div>
            </div>
            <div class="flex" data-index="4">
                <div class="item flex_column" data-index="9" data-code="542" data-example="1">06Lc<span class="fz_10 c_a1">(공육)</span></div>
                <div class="item flex_column" data-index="10" data-code="532" data-example="1">06w<span class="fz_10 c_a1">(육따블)</span></div>
                <div class="item flex_column" data-index="11" data-code="544" data-example="0">08Lc <span class="fz_10 c_a1">(공팔)</span></div>
                <div class="item flex_column" data-index="12" data-code="534" data-example="1">08w<span class="fz_10 c_a1">(팔따블)</span></div>
                <div class="item flex op0"></div>
            </div>
            <div class="flex" data-index="5">
                <div class="item flex_column" data-index="13" data-code="550" data-example="1">10Lc<span class="fz_10 c_a1">(텐)</span></div>
                <div class="item flex_column" data-index="14" data-code="552" data-example="1">380Lc<span class="fz_10 c_a1">(삼팔공)</span></div>
                <div class="item flex_column" data-index="15" data-code="554" data-example="1">460Lc<span class="fz_10 c_a1">(사육공)</span></div>
                <div class="item flex op0"></div>
                <div class="item flex op0"></div>
            </div>
        </div>
    </div>
    <h2 class="title1">옵션선택</h2>
    <div class="option flex_column">
        <div class="division_3 flex">
            <div class="item flex" data-value="크라샤" data-code="500" data-example="1">
                크라샤<span class="fz_10 fw_semobild   ml-05 mt-2">(파쇄기)</span>
            </div>
            <div class="item flex" data-value="돌집게" data-code="510" data-example="1">
                돌집게
            </div>
            <div class="item flex" data-value="뿌레카" data-code="520" data-example="1">
                뿌레카
            </div>
            <div class="item flex" data-value="그라플" data-code="530" data-example="1">
                그라플
            </div>
        </div>
        <div class="division_3 flex">
            <div class="item flex" data-value="채바가지" data-code="540" data-example="1">
                채바가지
            </div>
            <div class="item flex" data-value="고무궤도" data-code="560">
                고무궤도
            </div>
            <div class="item flex" data-value="회전링크" data-code="570">
                회전링크
            </div>
            <div class="item flex" data-value="지게발" data-code="590">
                지게발
            </div>
        </div>
    </div>
    <div class="car-example"></div>
    <div class="button flex apply-data">
        <div class="button_yellow flex">완료</div>
    </div>
</div>`;
    }
    /**
     * 화면 초기화
     * @param parent OptionWindow 인스턴스
     */
    init = function(parent) {
        this.parent=parent;

        console.log('window.option.excavator.init');
        this.parent.load();// 변수 초기화
        this.parent.draw();// 톤수,미터를 그린다.
        this.parent.initMainButtonHandler();// 메인 버튼을 클릭했을때
        this.parent.initSubButtonHandler();// 서브 버튼을 클릭했을때
        this.parent.initOptionHandler();// 옵션버튼 클릭시
        this.parent.initApplyHandler();// 완료버튼 클릭시
    }

    /**
     * 기종범위 코드를 얻는다.
     */
    updateRange = function (){
        const self = this;
        const arr = [];
        $('#'+this.parent.id+" .sub-button-area .item").each(function(){
            const idx = $(this).attr('data-index');
            if( self.parent.subIdxList.includes(idx) ) arr.push( $(this).attr('data-code'));
        });

        // const arr = this.parent.subCodeList;
        const min = Math.min(...arr);
        const max = Math.max(...arr);
        let range = '';

        if( this.parent.mainFunc=='toggle'){
            range = arr.join(',');
        }else{
            range = `${min}~${max}`;
        }
        const data = this.parent.data;
        data['car_range']=range;
    }
}
